// Copyright (c) 2017 Deere & Company

import PipCodeRequestsAccordionContainer from './pip-code-requests-accordion';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    pipCodeRequestItemToUpdate: state.tcsm.wip.pipCodeRequestItemToUpdate,
    pipCodeRequestModal: state.tcsm.wip.pipCodeRequestModal,
    pipCodeRequestSearchFilters: state.tcsm.wip.pipCodeRequestSearchFilters,
    pipCodeRequests: state.tcsm.wip.pipCodeRequests
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    const {
        approveDenyPipCodeRequest,
        closePipCodeRequestModal,
        exportPipCodeRequests,
        openPipCodeRequestModal,
        pipCodeRequestItemToUpdate,
        updatePipCodeRequestListFilterBy,
        updatePipCodeRequestListSortBy,
        updatePipCodeRequestListSortDirection,
        updatePipCodeRequestTcsmComments
    } = dispatchProps;

    return {
        ...stateProps,
        actions: {
            approveDenyPipCodeRequest,
            closePipCodeRequestModal,
            exportPipCodeRequests,
            openPipCodeRequestModal,
            pipCodeRequestItemToUpdate,
            updatePipCodeRequestListFilterBy,
            updatePipCodeRequestListSortBy,
            updatePipCodeRequestListSortDirection,
            updatePipCodeRequestTcsmComments
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(PipCodeRequestsAccordionContainer);



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/pip-code-requests/index.js